import { IAddress } from 'models';

const formatAddress = (a: IAddress): string =>
    a.street_line1 && a.city && a.state && a.zip
        ? `${a.street_line1}, ${a.city}, ${a.state} ${a.zip}`
        : '';

export { formatAddress };
